export default __webpack_public_path__ + "static/media/arrow_left.dc4cf9ed.svg";